module.exports = __webpack_public_path__ + "img/ico_comment--orange.6a762436.svg";